<template>
    <section id="online-users">
        <h1><i class="fa fa-fw fa-sun-o"></i> Online Users</h1>
        <section id="online-users-list">
            <a :href="`/Profile/${user.stringUrl}`" target="_blank" v-for="user in onlineUsers" :key="user.id">
                <img class="avatar" :src="avatarImage(user)"/>
                <span>{{user.alias}}</span>
            </a>
        </section>
    </section>
</template>

<script>
    export default {
        name: 'OnlineUsers',

        methods: {
            avatarImage(user){
                let avatarId = new Date(user.avatarUpdate).getTime();

                if (user.hasAvatar) {
                    return `/userdata/avatars/${user.id}.jpg?v=${avatarId}`;
                } else {
                    return '/defaultProfilePic.png';
                }
            }
        },

        computed: {
            onlineUsers(){
                return this.$store.state.onlineUsersModel.onlineUsers;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// OnlineUsers.vue?039526c2